import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '产品服务',
    links: [
      { label: '安全登录', path: '/category/anquan-denglu' },
      { label: '账户管理', path: '/category/zhanghu-guanli' },
      { label: '企业方案', path: '/category/jishu-zixun' },
      { label: '使用指南', path: '/category/shiyong-zhinan' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '发展历程', path: '/about' },
      { label: '资质认证', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', path: '/article/zhanghu-anquan-changjian-wenti-jieda' },
      { label: '安全指南', path: '/article/kaiyun-denglu-anquan-baohu-zhinan' },
      { label: '平台动态', path: '/category/pingtai-dongtai' },
      { label: '用户协议', path: '/' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 whitespace-nowrap mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-cloud-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  开云登录
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                安全、快速、稳定的登录服务平台。为超过5000万用户和200家企业提供值得信赖的登录认证服务。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 开云登录 版权所有 | 京ICP备2024000001号 | 京公网安备 11010802000001号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
                Cookie设置
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}